module.exports = __webpack_public_path__ + "media/images/athletes/1075-da22053cc95b24129b5a2bd9aaede4f8.png";